import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Icon, Popup } from 'semantic-ui-react';
import { colors } from 'utils/colors';
import { SimpleTable } from './SimpleTable';
import assignColors from '../utils/assignColors';
import { translateAssetClass } from '../utils/helpers';
import { translation } from '../modules/Translation/scorecard';

class AssetLegend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      narrow: window.innerWidth < 1100,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentDidUpdate() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({ narrow: window.innerWidth < 1100 });
  };

  render() {
    const {
      data,
      french,
      diversification,
      partnerName,
      regionAssets,
      hideZeros,
    } = this.props;
    const { narrow } = this.state;
    const language = french ? 'fr' : 'en';
    return (
      <TableWrapper narrow={narrow} diversification={diversification}>
        <SimpleTable>
          <thead>
            <tr>
              <th>{translateAssetClass(french, 'Asset Class')}</th>
              {!narrow && <th>{translateAssetClass(french, 'Allocation')}</th>}
            </tr>
          </thead>
          <tbody>
            {data &&
              Object.keys(data)
                .filter((assetClass) => !hideZeros || data[assetClass] !== 0)
                .map((assetClass, i) => {
                  const parentValue = data[assetClass];
                  const subRows = regionAssets[assetClass] || [];

                  return (
                    <React.Fragment key={i}>
                      <tr className="header">
                        <td>
                          <div className="table-item">
                            <Dot
                              color={
                                assignColors(Object.keys(data), partnerName)[i]
                              }
                            />
                            {(assetClass === 'Misc.' ||
                              assetClass === 'Fixed Income' ||
                              assetClass === 'Derivatives' ||
                              assetClass === 'Cash') &&
                            diversification ? (
                              <div>
                                <b>{translateAssetClass(french, assetClass)}</b>
                                <Popup
                                  trigger={
                                    <Icon
                                      name="question circle outline"
                                      style={{
                                        fontSize: '15px',
                                        verticalAlign: 'initial',
                                        color: 'dimgrey',
                                      }}
                                    />
                                  }
                                  position="top center"
                                  wide
                                >
                                  {assetClass === 'Misc.'
                                    ? translation[language].ASSETCLASS_MISC
                                    : assetClass === 'Fixed Income'
                                    ? translation[language]
                                        .ASSETCLASS_Fixed_Income
                                    : assetClass === 'Derivatives'
                                    ? translation[language]
                                        .ASSETCLASS_DERIVATIVES
                                    : translation[language].ASSETCLASS_CASH}
                                </Popup>
                              </div>
                            ) : assetClass === 'Asset Allocation' ? (
                              <div>
                                <b>{translateAssetClass(french, assetClass)}</b>
                                <Popup
                                  trigger={
                                    <Icon
                                      name="question circle outline"
                                      style={{
                                        fontSize: '15px',
                                        verticalAlign: 'initial',
                                        color: 'dimgrey',
                                      }}
                                    />
                                  }
                                  position="top center"
                                  wide
                                >
                                  {assetClass === 'Asset Allocation' &&
                                    translation[language]
                                      .ASSETCLASS_ASSET_ALLOCATION}
                                </Popup>
                              </div>
                            ) : (
                              <b>{translateAssetClass(french, assetClass)}</b>
                            )}
                          </div>
                        </td>
                        <td className="allocation">
                          <b>{Math.round(parentValue * 10000) / 100}%</b>
                        </td>
                      </tr>

                      {subRows
                        .filter(
                          (r) =>
                            (assetClass === 'Equity' ||
                              assetClass === 'Fixed Income') &&
                            (!hideZeros || r.value !== 0)
                        )
                        .map((r, j) => (
                          <tr key={`${i}-${j}`} className="sub-row">
                            <td>
                              <div className="sub-item">
                                <div className="sub-item-left">
                                  <Dot style={{ visibility: 'none' }} />
                                  <span className="sub-item-label">
                                    {translateAssetClass(french, r.region)}
                                  </span>
                                </div>
                              </div>
                            </td>
                            <td className="allocation">
                              {Math.round(r.value * 10000) / 100}%
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  );
                })}
          </tbody>
        </SimpleTable>
      </TableWrapper>
    );
  }
}

AssetLegend.propTypes = {
  data: PropTypes.object,
  french: PropTypes.bool,
  diversification: PropTypes.bool,
  partnerName: PropTypes.string,
  regionAssets: PropTypes.object,
  hideZeros: PropTypes.bool,
};

AssetLegend.defaultProps = {
  data: {},
  french: false,
  diversification: false,
  partnerName: '',
  regionAssets: {},
  hideZeros: true,
};

export default AssetLegend;

const TableWrapper = styled.div`
  table {
    color: black !important;
    text-align: left;
    min-width: ${(props) =>
      props.diversification
        ? props.narrow
          ? '100px'
          : '180px'
        : props.narrow
        ? '120px'
        : '245px'};
    width: 265px;
    .table-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      column-gap: 5px;
    }
  }
  .header {
    border-top: 1px solid ${colors.lightGrey};
    border-bottom: 1px solid ${colors.lightGrey};
  }

  .sub-row {
    color: rgba(0, 0, 0, 0.7);
  }

  .sub-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .sub-item-left {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .allocation {
    min-width: 3.5rem;
    text-align: right;
    padding-right: 2.5rem;
  }
`;

const Dot = styled.div`
  height: 12px;
  width: 12px;
  min-width: 12px;
  min-height: 12px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
`;
